import type { RouteRecordRaw } from 'vue-router'

const routes: RouteRecordRaw[] = [
  {
    meta: {
      icon: 'carbon:graph-aggregator',
      order: 90,
      title: '素材分析',
    },
    name: 'MaterialAnalysis',
    path: '/material-analysis',
    children: [
      {
        name: 'MaterialLibrary',
        path: '/material-library',
        component: () =>
          import('#/views/material-analysis/material-library/index.vue'),
        meta: {
          icon: 'carbon:apps',
          title: '素材库',
          keepAlive: true,
        },
      },
      {
        name: 'MaterialAccountManagement',
        path: '/account-management',
        component: () =>
          import('#/views/material-analysis/account-management/index.vue'),
        meta: {
          icon: 'carbon:user',
          title: '账号管理',
          keepAlive: true,
        },
      },
      {
        name: 'MaterialAdAccounts',
        path: '/ad-accounts',
        component: () =>
          import('#/views/material-analysis/account-management/index.vue'),
        meta: {
          hideInMenu: true,
          title: '账号管理',
          keepAlive: true,
        },
      },
    ],
  },
]

export default routes
